export default __webpack_public_path__ + "static/media/illustration-phones.fd23559f.svg";